import type { ReactNode } from 'react'
import React from 'react'
import { H2 } from '@fs/zion-ui'
import { css } from '@emotion/core'

const headingCss = css`
  padding-inline-end: 4px;
`

const countCss = css`
  font-weight: normal;
  flex-shrink: 0;
`

type SectionHeadingProps = {
  heading: ReactNode
  count?: number
  ariaLabel?: string
}

export default function SectionHeading({ heading, count, ariaLabel }: SectionHeadingProps): JSX.Element {
  return (
    <H2 data-testid="section-card-header" size="H5" aria-label={ariaLabel}>
      <span css={headingCss}>
        {heading}
        {!!count && <span css={countCss}> ({count})</span>}
      </span>
    </H2>
  )
}
